import { io, Socket } from 'socket.io-client';
import { getAuthToken } from '../api/client';
import { WS_BASE } from './wsBase';

let socket: Socket | null = null;

// Сокет краша (namespace /crash). Vite проксирует /socket.io на backend.
export function getCrashSocket(): Socket {
  if (socket && socket.connected) return socket;
  if (!socket) {
    socket = io(WS_BASE + '/crash', { auth: { token: getAuthToken() || '' }, autoConnect: true });
  } else {
    socket.auth = { token: getAuthToken() || '' };
    socket.connect();
  }
  return socket;
}

export function disconnectCrashSocket() {
  socket?.disconnect();
}
